import React from 'react'

const categories = [
  { icon: '🥦', label: 'Food & Groceries' },
  { icon: '🧴', label: 'Daily Essentials' },
  { icon: '✨', label: 'Lifestyle Products' },
  { icon: '🎁', label: 'Seasonal Items' },
]

const GroupBuySection = () => (
  <section className='groupbuy-section' id='groupbuy'>
    <div className='landing-shell groupbuy-section__grid'>
      <div>
        <p className='section-label section-label--teal'>What is Group-Buy?</p>
        <h2 className='groupbuy-section__title'>
          Buy as one.
          <br />
          Save as many.
        </h2>
      </div>

      <div className='groupbuy-section__content'>
        <p>
          A group-buy brings a community together to place one large order, unlocking better prices
          for everyone. Customers enjoy savings, while merchants can partner with us to promote
          their products and reach many buyers in a single campaign.
        </p>

        <div className='groupbuy-section__pills'>
          {categories.map((category) => (
            <span key={category.label} className='groupbuy-pill'>
              {category.icon} {category.label}
            </span>
          ))}
        </div>
      </div>
    </div>
  </section>
)

export default GroupBuySection
